import React from 'react';

export default function PkgDetails() {
  return (

    <>
      <div className='container-fluid'>


      </div>



    </>


  )
}
